import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M21.79,10.26a6.86,6.86,0,1,0,6.85,6.86A6.87,6.87,0,0,0,21.79,10.26Zm0,12.42a5.56,5.56,0,1,1,5.55-5.56A5.57,5.57,0,0,1,21.79,22.68Z' }),
  React.createElement('polygon', { points: '22.44 13.83 21.14 13.83 21.14 16.47 18.5 16.47 18.5 17.77 21.14 17.77 21.14 20.41 22.44 20.41 22.44 17.77 25.07 17.77 25.07 16.47 22.44 16.47 22.44 13.83' }),
  React.createElement('path', { d: 'M11.41,2.67h-6a2.05,2.05,0,1,0,0,4.1h.25V26.58a2.75,2.75,0,1,0,5.49,0V6.77h.26a2.05,2.05,0,1,0,0-4.1ZM8.41,28A1.45,1.45,0,0,1,7,26.58v-13H9.85v13A1.45,1.45,0,0,1,8.41,28ZM9.85,12.31H7V6.77H9.85Zm1.56-6.84h-6a.75.75,0,1,1,0-1.5h6a.75.75,0,1,1,0,1.5Z' })
));